import type { TCardCategoryOrientation } from '../../types'
import * as Comp from './card-category.label.styles'

type TCardCategoryLabelProps = {
  orientation?: TCardCategoryOrientation
  children: string
  disabled?: boolean
  testID?: string
}

export function CardCategoryLabel({
  orientation,
  children,
  disabled,
  testID,
}: TCardCategoryLabelProps) {
  const componentProperties = {
    orientation,
    hasDisabled: !!disabled,
  }
  const numberOfLines = orientation === 'horizontal' ? 1 : 2

  return (
    <Comp.Label
      numberOfLines={numberOfLines}
      testID={testID}
      {...componentProperties}
    >
      {children}
    </Comp.Label>
  )
}
